
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/[id]",
      function () {
        return require("private-next-pages/news/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/[id]"])
      });
    }
  